import { useUiStrings } from '@/hooks/useUiStrings'
import type { BacklogTicketCard } from './assist.types'

type AssistBacklogTicketCardProps = {
  card: BacklogTicketCard
}

export default function AssistBacklogTicketCard({ card }: AssistBacklogTicketCardProps) {
  const { t } = useUiStrings()

  return (
    <div
      className="rounded-lg border border-slate-200 bg-white p-2.5 text-xs dark:border-[var(--border-color)] dark:bg-[var(--bg-tertiary)]"
      data-testid={`copilot-ticket-${card.issueKey}`}
    >
      <p className="font-semibold text-slate-900 dark:text-[var(--text-primary)]">
        {card.issueKey} — {card.summary}
      </p>
      <p className="mt-1 text-slate-600 dark:text-[var(--text-secondary)]">
        {card.assignee} · {card.ticketStatus} · {card.dueDate}
      </p>
      <a
        href={card.link}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 inline-block text-blue-600 hover:underline dark:text-[var(--accent)]"
      >
        {t.assistTicketLink}
      </a>
    </div>
  )
}
